import { create } from 'zustand';

import { Space } from '../mainApi';

export type SpacesOrderBy = 'title' | 'created';
export type MainFilter = 'home' | 'archived' | 'workspace' | 'templates';

type MainState = {
  orderBy: SpacesOrderBy;
  filter: MainFilter;
  selectedWorkspaceId: string | null;
  setOrderBy: (orderBy: SpacesOrderBy) => void;
  selectHome: () => void;
  selectArchived: () => void;
  selectTemplates: () => void;
  selectWorkspace: (workspaceId: string) => void;
};

export const useMainStore = create<MainState>((set) => ({
  orderBy: 'created',
  filter: 'home',
  selectedWorkspaceId: null,
  setOrderBy: (orderBy) => set({ orderBy }),
  selectHome: () => set({ filter: 'home', selectedWorkspaceId: null }),
  selectArchived: () => set({ filter: 'archived', selectedWorkspaceId: null }),
  selectTemplates: () => set({ filter: 'templates', selectedWorkspaceId: null }),
  selectWorkspace: (workspaceId) =>
    set({
      filter: 'workspace',
      selectedWorkspaceId: workspaceId,
    }),
}));

export const getVisibleSpaces = (
  spaces: Space[],
  filter: MainFilter,
  selectedWorkspaceId: string | null,
  orderBy: SpacesOrderBy
): Space[] => {
  const filtered = spaces.filter((space) => {
    if (filter === 'archived') {
      return Boolean(space.archived);
    }

    if (filter === 'workspace') {
      if (!selectedWorkspaceId) {
        return false;
      }

      return String(space.workspace ?? '') === selectedWorkspaceId && !space.archived;
    }

    if (filter === 'templates') {
      return false;
    }

    return !space.workspace && !space.archived;
  });

  return filtered.sort((a, b) => {
    if (orderBy === 'created') {
      const aDate = new Date(
        (a.created as string | undefined) ?? (a.dateCreated as string | undefined) ?? 0
      ).getTime();
      const bDate = new Date(
        (b.created as string | undefined) ?? (b.dateCreated as string | undefined) ?? 0
      ).getTime();
      return bDate - aDate;
    }

    return (a.title ?? '').localeCompare(b.title ?? '');
  });
};
